import { isUndefined } from 'lodash';
import { useContext } from 'react';
import { number, object, string } from 'yup';
import { useParseParams } from '@hooks/params';
import { FilterContext, FilterType } from './context';

export const useFilterContext = () => {
  const context = useContext(FilterContext);
  if (isUndefined(context)) throw new Error('useFilterContext must be used within a FilterProvider');
  return context;
};

export const useFilterParams = () => {
  const schema = object({
    search: string().default(''),
    province: string().default(''),
    insurerId: string().default(''),
    page: number().default(1),
  });
  return useParseParams<FilterType>(schema);
};
